import { useTranslation } from 'react-i18next';

import styles from './PlayingNowBadge.module.scss';

/**
 * "X playing" badge on a lobby tile. Count and label are separate nodes for styling and locale number
 * formatting; `count` still drives the plural form.
 */
interface PlayingNowBadgeProps {
  count: number;
  testId?: string;
}

export function PlayingNowBadge({ count, testId = 'playing-now-badge' }: PlayingNowBadgeProps) {
  const { t, i18n } = useTranslation();

  return (
    <div className={styles.badge} data-testid={testId}>
      <span className={styles.dot} />
      <span className={styles.count}>{count.toLocaleString(i18n.language)}</span>
      <span className={styles.label}>{t('games.playingNow', { count })}</span>
    </div>
  );
}
